import { InjectionToken } from '@angular/core';
import { CwcInputDate } from '@cmx-web-components/angular';
import { Observable } from 'rxjs';

export type CxUiDesignVersion = CwcInputDate['designVersion'];
export const CX_DESIGN_VERSION_TOKEN = new InjectionToken<CxUiDesignVersion | Observable<CxUiDesignVersion>>(
  'Token for providing design version for Cemex components',
);

export type CxUiRTL = CwcInputDate['rtl'];
export const CX_RTL_TOKEN = new InjectionToken<CxUiRTL | Observable<CxUiRTL>>(
  'Token for providing RTL for Cemex components',
);
